// Bridge to native (Capacitor) features when the web app is loaded inside the
// Lattice mobile shell. When not native, falls back to the Web Notifications API.
// Native notifications use the default channel so they follow the phone's own
// sound / vibration / silent settings exactly.

export const isNative = () =>
  !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

const plugin = (name) => window.Capacitor?.Plugins?.[name];

export async function initNotifications() {
  if (isNative()) {
    const LN = plugin("LocalNotifications");
    if (!LN) return;
    try {
      await LN.requestPermissions();
      if (LN.createChannel) {
        // importance 5 (HIGH) = può fare suono/heads-up; il SUONO e la VIBRAZIONE
        // effettivi seguono le impostazioni di sistema del telefono per l'app.
        await LN.createChannel({ id: "lattice", name: "Lattice", importance: 5, visibility: 1, vibration: true });
      }
    } catch { /* noop */ }
    return;
  }
  if ("Notification" in window && Notification.permission === "default") {
    try { await Notification.requestPermission(); } catch { /* noop */ }
  }
}

let _nid = 1;
export async function notify(title, body, route) {
  if (isNative()) {
    const LN = plugin("LocalNotifications");
    try {
      await LN?.schedule({
        notifications: [{
          id: _nid++, title, body, channelId: "lattice",
          smallIcon: "ic_stat_lattice",
          extra: route ? { route } : undefined,
          schedule: { at: new Date(Date.now() + 80) },
        }],
      });
      return;
    } catch { /* fall through */ }
  }
  try {
    if ("Notification" in window && Notification.permission === "granted") {
      const n = new Notification(title, { body, icon: "/assets/hero-lattice.png", tag: route || title });
      if (route) n.onclick = () => { window.focus(); window.location.href = route; };
      setTimeout(() => n.close?.(), 7000);
    } else if (navigator.vibrate) {
      navigator.vibrate(200);
    }
  } catch { /* noop */ }
}
